import { FITNESS_GUIDES } from 'analytics/constants/ids';

import { trackScreenLoad, trackClick } from 'services/Analytics';

export const trackFitnessGuidePageLoad = () => trackScreenLoad(FITNESS_GUIDES);

export const trackDownloadGuideClick = (guideInternalName: string) =>
    trackClick(FITNESS_GUIDES, { event_action: guideInternalName });
